import { getData, exportData } from './base';

// 申请主体管理 列表
export const getApplicantList = data => getData(data, "/uom/applicantV2/getUserList");
// 申请主体管理 新增
export const applicantAdd = data => getData(data, "/uom/applicantV2/add");
// 申请主体管理 删除
export const applicantDel = data => getData(data, "/uom/applicant/del");
// 申请主体管理 编辑
export const applicantUpdate = data => getData(data, "/uom/applicantV2/update");
// 申请主体管理 详情
export const applicantDetail = data => getData(data, "/uom/applicantV2/detail");
// 申请主体审核 审核通过、审核不通过、审核通过并处理下一单
export const applicantAudit = data => getData(data, "/uom/applicant/audit");
// 下载生成委托书模板
export const downloadPowerAttorney = data => getData(data, "/upload/downloadPowerAttorneyV2");
// 判断同一个主体是否有三个申请主体
export const checkRepeat = data => getData(data, "/uom/applicantV2/checkRepeat");
// 搜索工商信息
export const queryCompanyInfo = data => getData(data, "/account/queryCompanyInfo");
// 模糊查询工商信息
export const queryCompanyByKeyword = data => getData(data, "/account/queryCompanyByKeyword");
// 手动上传文件 生成二维码接口
export const generateCode = data => getData(data, "/uom/applicantfile/generateCode");
// 一直请求获取上传后的文件
export const getFile = data => getData(data, "/uom/applicantfile/getFile");
// 根据申请主体ID查询对应审核不通过的智能注册订单列表
export const listIntelligentOrderNotPassByApplicant = data => getData(data, "/order/listIntelligentOrderNotPassByApplicant");
// 申请主体ID对应审核不通过的订单提交审核
export const syncNotPassOrderApplicantInfo = data => getData(data, "/order/syncNotPassOrderApplicantInfo");

// 申请人黑名单
export const getQueryBlackList = data => getData(data, "/common/queryBlackListApi");
// 获取国家信息
export const queryBrandRegisterCountryList = data => getData(data, "/order/queryBrandRegisterCountryList");
// 获取省市县信息
export const queryRegionsMills = data => getData(data, "/common/queryRegionsMills");
// 获取最新省市县信息
export const getBrandRegions = data => getData(data, "/common/getBrandRegions");
// 身份证、营业执照识别接口
export const recogniseInfoV3 = data => getData(data, "/common/recogniseInfoV3");
// 生成委托书
export const generatePowerAttorney = data => getData(data, "/upload/generatePowerAttorney2");
// 生成委托书盖章文件
export const genWtsJpgV2 = data => getData(data, "/upload/genWtsJpgV2");


// 导出申请主体管理列表
export const exportApplicantList = data => exportData(data, "/uom/applicantV2/exportUserList");